import React from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import RequireAuth from "./AuthRouter";
import Container from "./Container";
import LoginPage from "../pages/LoginPage";
import NotFoundPage from "../pages/NotFoundPage";
import Dashboard from "../components/Dashboard";
import MyProfilePage from "../pages/MyProfilePage";
import SupportTable from "../components/tables/SupportTable";
import DocsTable from "../components/tables/DocsTable";
import DetailsTable from "../components/tables/DetailsTable";
import UsersTable from "../components/tables/UsersTable";
import AuditsTable from "../components/tables/AuditsTable";
import AdminCustomersTable from "../components/tables/AdminCustomersTable";
import LGPDPage from "../pages/LGPDPage";
import AdminQueriesTable from "../components/tables/AdminQueriesTable";
import AdminCustomerForm from "../components/forms/AdminCustomerForm";
import InvoicesTable from "../components/tables/InvoicesTable";
import QueriesCreditTable from "../components/tables/QueriesCreditTable";
import QueriesCadastralTable from "../components/tables/QueriesCadastralTable";
import AdminRepresentativesTable from "../components/tables/AdminRepresentativesTable";
import AdminRepresentativeForm from "../components/forms/AdminRepresentativeForm";
import QueriesAutoTable from "../components/tables/QueriesAutoTable";
import PDFQueryPage from "../pages/PDFQueryPage";
import AdminHistoryTable from "../components/tables/AdminHistoryTable";
import ReportTable from "../components/tables/ReportTable";
import AdminPaymentsTable from "../components/tables/AdminPaymentsTable";
import AdminUsersTable from "../components/tables/AdminUsersTable";
import AdminTablesTable from "../components/tables/AdminTablesTable";
import ChargesTable from "../components/tables/ChargesTable";
import ReportSurveysTable from "../components/tables/ReportSurveysTable";
import Survey from "../components/survey/Survey";
import SurveysTable from "../components/tables/SurveysTable";
import SurveyConfig from "../components/survey/SurveyConfig";
import AdminReportSurveysTable from "../components/tables/AdminReportSurveysTable";
import CVsTable from "../components/tables/CVsTable";
import ComunicateSell from "../components/comunicate-sell/ComunicateSell";
import ReportCvsTable from "../components/tables/ReportCvsTable";
import AdminProvidersTable from "../components/tables/AdminProvidersTable";
import RegisterPage from "../pages/RegisterPage";
import HelpCenterTable from "../components/tables/HelpCenterTable";
import AdminHelpCenterTable from "../components/tables/AdminHelpCenterTable";
import ForgotPassword from "../pages/ForgotPassword";
import CompanyDetailsPage from "../pages/CompanyDetailsPage";
import ReportsPage from "../pages/ReportsPage";
import AdminPage from "../pages/AdminPage";
import ReviewQuery from "../pages/ReviewQuery";
import LocalizaPage from "../pages/LocalizaPage";
import AdminCloseTable from "../components/tables/AdminCloseTable";
import ReviewDiario from "../pages/ReviewDiarioPage";
import FaqPage from "../pages/FaqPage";
import CompareQueriesPage from "../pages/CompareQueriesPage";
import CompareQueriesPicker from "../pages/CompareQueriesPicker";
import RepresentativeTablePage from "../pages/RepresentativeTablePage";
import FinancialRepresentative from "../pages/FinancialRepresentative";
import MyCustomersTable from "../components/tables/MyCustomersTable";
import NegativeListPage from "../components/tables/NegativeListPage";
import NegativeCreatePage from "../components/negatives/NegativeCreatePage";
import CompanyDetailsSellerPage from "../pages/CompanyDetailsSellerPage";
import InvoicesPage from "../pages/InvoicesPage";
import CreditEnginePage from "../pages/CreditEnginePage";

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/review-query" element={<ReviewQuery />} />
        <Route path="/recuperar-senha" element={<ForgotPassword />} />
        <Route path="/register/:uuid" element={<RegisterPage />} />
        <Route
          path="/"
          element={
            <RequireAuth>
              <Container>
                <Outlet />
              </Container>
            </RequireAuth>
          }
        >
          <Route path="/" element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="users" element={<UsersTable />} />
          <Route path="queries/details" element={<DetailsTable />} />
          <Route path="queries/credits" element={<QueriesCreditTable />} />
          <Route
            path="/queries/compare/pick"
            element={<CompareQueriesPicker />}
          />
          <Route path="/queries/compare" element={<CompareQueriesPage />} />
          <Route
            path="queries/cadastrals"
            element={<QueriesCadastralTable />}
          />
          <Route path="queries/autos" element={<QueriesAutoTable />} />
          <Route path="query/generate-pdf" element={<PDFQueryPage />} />
          <Route path="localize" element={<LocalizaPage />} />
          <Route path="credit-engine" element={<CreditEnginePage />} />
          <Route path="negatives" element={<NegativeListPage />} />
          <Route path="negatives/create" element={<NegativeCreatePage />} />
          <Route path="surveys" element={<SurveysTable />} />
          <Route path="survey/new" element={<Survey />} />
          <Route path="survey/config" element={<SurveyConfig />} />
          <Route path="cvs" element={<CVsTable />} />
          <Route path="cv/new" element={<ComunicateSell />} />
          <Route path="charges" element={<ChargesTable />} />
          <Route path="reports/queries" element={<ReportTable />} />
          <Route path="reports/surveys" element={<ReportSurveysTable />} />
          <Route path="reports/cvs" element={<ReportCvsTable />} />
          <Route
            path="admin/financial-representative"
            element={<FinancialRepresentative />}
          />
          <Route path="invoices" element={<InvoicesTable />} />
          <Route path="faq" element={<FaqPage />} />
          <Route path="support" element={<HelpCenterTable />} />
          <Route path="audits" element={<AuditsTable />} />
          <Route path="admin/queries" element={<AdminQueriesTable />} />
          <Route
            path="admin/representatives"
            element={<AdminRepresentativesTable />}
          />
          <Route path="my-customers" element={<MyCustomersTable />} />
          <Route path="admin/customers" element={<AdminCustomersTable />} />
          <Route path="admin/customers/:id" element={<CompanyDetailsPage />} />
          <Route
            path="admin/customer-seller/:id"
            element={<CompanyDetailsSellerPage />}
          />
          <Route path="admin/history" element={<AdminHistoryTable />} />
          <Route path="admin/providers" element={<AdminProvidersTable />} />
          <Route path="admin/reports" element={<ReportsPage />} />
          <Route path="admin/users" element={<AdminUsersTable />} />
          <Route path="admin/invoices" element={<InvoicesPage />} />
          <Route path="admin/daily-review" element={<ReviewDiario />} />
          <Route path="admin/new-customer" element={<AdminCustomerForm />} />
          <Route
            path="admin/new-representative"
            element={<AdminRepresentativeForm />}
          />
          <Route path="admin/payments" element={<AdminPaymentsTable />} />
          <Route path="admin/tables" element={<AdminTablesTable />} />
          <Route
            path="admin/reports/surveys"
            element={<AdminReportSurveysTable />}
          />
          <Route path="admin/support" element={<AdminHelpCenterTable />} />
          <Route
            path="admin/table-cost"
            element={<RepresentativeTablePage />}
          />
          <Route path="admin/admin" element={<AdminPage />} />
          <Route path="docs" element={<DocsTable />} />
          <Route path="profile" element={<MyProfilePage />} />
          <Route path="support" element={<SupportTable />} />
          <Route path="lgpd" element={<LGPDPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
